import { Box } from '@zoopla-eng/zds/box';
import { fontGroups } from '@zoopla-eng/zds/themes';
import * as React from 'react';
import JumpLink from '../components/JumpLink';
import {
    textStyle,
    heading2Style,
    heading3Style,
    heading4Style
} from './renderHeadingOrJumpLink.styles.css';

export const renderHeadingOrJumpLink = (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _node: Record<string, any>,
    children: React.ReactNode
) => {
    const type = _node?.['nodeType'];
    const text = _node?.['content'][0]?.value;

    // If we have no text but children then it is likely the whole heading is a link, and we
    // don't want to create JumpLinks around real links. Ideally article headings should not
    // be links but we must support them for legacy articles.
    if (!text && children) {
        switch (type) {
            case 'heading-2':
                return (
                    <h2 className={`${heading2Style} ${fontGroups.plate}`}>
                        {children}
                    </h2>
                );
            case 'heading-3':
                return (
                    <h3 className={`${heading3Style} ${fontGroups.mug}`}>
                        {children}
                    </h3>
                );
            case 'heading-4':
                return (
                    <h4 className={`${heading4Style} ${fontGroups.whisk}`}>
                        {children}
                    </h4>
                );
            default:
                return (
                    <p className={`${textStyle} ${fontGroups.ladle}`}>
                        {children}
                    </p>
                );
        }
    }
    return (
        <Box pb="S500" fontGroup="plate">
            <JumpLink type={type} text={text}>
                {children}
            </JumpLink>
        </Box>
    );
};
